export default __webpack_public_path__ + "static/product-bg-desktop-e1543776e8a2a862bb8fba51d677dd49.png";